import {AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {
  ApDynComponentComponent
}                                                                             from '../../../ap-dyncomponent/ap-dyncomponent.component';
import {BehaviorSubject, combineLatest, Observable, of, Subscription}         from 'rxjs';
import {
  ApDynGridColumnConfigBase
}                                                                             from '../../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridPagerConfigBase
}                                                                             from '../../../ap-dyngrids/config/ap-dyn-grid-pager-config-base';
import {
  MonitoringChildGridItem,
  MonitoringGridItem,
  PlanBookApplicationDateObject
}                                                                             from '../../types/monitoring.types';
import {debounceTime, filter, map}                                            from 'rxjs/operators';
import {
  MonitoringFieldStore
}                                                                             from '../../../stores/fields/monitoring-field.store';
import {
  MonitoringDetailStore
}                                                                             from '../../../stores/fields/monitoring-detail.store';
import {
  FieldStore
}                                                                             from '../../../stores/farm/field.store';
import {
  ApUtilService
}                                                                             from '../../../ap-utils/service/ap-util.service';
import {
  ApDynGridDetailsBaseConfig
}                                                                             from '../../../ap-dyngrids/config/details/ap-dyn-grid-details-base-config';
import {
  IGridStatus
}                                                                             from '../../../ap-interface/interfaces/ap-grid-status.interface';
import {
  SettingsStore
}                                                                             from '../../../stores/base-data/settings.store';
import {
  ApDateService,
  DateDiffType
}                                                                             from '../../../ap-core/services/ap-date-service';
import {
  ApColumnState
}                                                                             from '../../../ap-interface/enums/ap-column-state.enum';
import {
  ApGetCropService
}                                                                             from '../../../stores/services/ap-get-crop.service';
import {
  LoginStore
}                                                                             from '../../../stores/login/login.store';
import {
  FormStore
}                                                                             from '../../../stores/layout/form.store';
import {
  ApMonitoringFieldEntryComponent
}                                                                             from '../../../entry-components/ap-field-management-entry-components/ap-monitoring-field/ap-monitoring-field-entry.component';
import {
  CampaignYearStore
}                                                                             from '../../../stores/login/campaignyear.store';
import {
  MonitoringTypeStore
}                                                                             from '../../../stores/fields/monitoring-type.store';
import {
  ApMonitoringDetailEntryComponent
}                                                                             from '../../../entry-components/ap-field-management-entry-components/ap-monitoring-detail/ap-monitoring-detail-entry.component';
import {
  MonitoringDetailEntryComponentData
}                                                                             from '../../../entry-components/ap-field-management-entry-components/ap-monitoring-detail/monitoring-detail-entry.types';
import {ApStatsType, MapViewCurrentMenu, MapViewMode}                         from '../../../ap-interface';
import {
  MapViewStore
}                                                                             from '../../../stores/layout/mapview.store';
import {
  LanguageStore
}                                                                             from '../../../stores/translation/language.store';
import {
  DropDownButtonData
}                                                                             from '../../../ap-dyngrids/config/ap-dyn-grid-button-column-config';
import {MonitoringConfig}                                                     from './monitoring.config';
import {
  TranslationStore
}                                                                             from '../../../stores/translation/translation.store';
import {
  ModalDialogStore
}                                                                             from '../../../stores/dialog/modal.dialog.store';
import {
  ModalDialogButtonKeys,
  ModalDialogPresets
}                                                                             from '../../../stores/dialog/modal.dialog.presets';
import {
  PlantProtectionPlanBookStore
}                                                                             from '../../../stores/plant-protection/plant-protection-planbook.store';
import {
  NFertilizationStore
}                                                                             from '../../../stores/n-fertilization/n-fertilization.store';
import {
  NFertilizationService
}                                                                             from '../../../services/data/n-fertilization.service';
import {
  PlantProtectionService
}                                                                             from '../../../services/data/plant-protection.service';
import {
  StatisticStore
}                                                                             from '../../../stores/statistic/statistic.store';
import {
  ApTranslationService
}                                                                             from '../../../ap-utils/service/ap-translation.service';
import {
  StatisticService
}                                                                             from '../../../services/data/statistic.service';
import {
  CropGroupStore
}                                                                             from '../../../stores/base-data/crop.groups.store';
import {
  nameOf
}                                                                             from '../../../ap-core/utils/ap-name-of';
import {
  GenericChartConfig,
  GenericSeriesConfig,
  GenericSeriesData,
  GenericYAxisConfig
}                                                                             from '../../../statistics/components/charts/ap-generic-chart.types';
import {
  MapStore
}                                                                             from '../../../stores/map/map.store';
import {Point}                                                                from 'ts-tooling';
import Polygon                                                                from 'ol/geom/Polygon';
import {ApGuidUtil}                                                           from '../../../ap-utils';
import {
  IContentNRelatedPlanBook
}                                                                             from '../../../types/n-fertilization.types';
import {
  BasicFertilisationSummariesStore
}                                                                             from '../../../stores/taskmanagement/basic.fertilisation.summaries.store';
import IGuid = System.IGuid;
import IMonitoringDetail = Data.Fields.IMonitoringDetail;
import IMonitoringType = Data.Fields.IMonitoringType;
import IField = Data.FieldManagement.IField;
import IFieldGeom = Data.FieldManagement.IFieldGeom;

@Component({
  selector: 'ap-monitoring',
  template: `
    <ap-dyncomponent [headerIcon]="'ap-icon-fields'"
                     [filterTooltip]="'filterTooltip'"
                     [caption]="'Monitoring'"
                     [canSearch]="true"
                     [canCreate]="true"
                     [columns]="columns$ | async"
                     [details]="detailsColumns$ | async"
                     [pager]="pager"
                     [items]="items$ | async"
                     [loading$]="loading$"
                     [selectable]="{checkboxOnly: false, mode: 'multiple'}"
                     (create)="onCreate()">
    </ap-dyncomponent>
  `,
  styles: [],
  providers: [
    MonitoringConfig
  ]
})
export class MonitoringComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(ApDynComponentComponent, {static: false}) dynComponent: ApDynComponentComponent;
  public columns$: Observable<ApDynGridColumnConfigBase[]> = of([]);
  public detailsColumns$: Observable<ApDynGridDetailsBaseConfig> = of(undefined);
  public pager: ApDynGridPagerConfigBase = undefined;
  public loading$ = of(true);
  public items$ = new BehaviorSubject<MonitoringGridItem[]>([]);

  private _statisticUpdateRequested = new EventEmitter<void>();
  private _subscriptions: Subscription[] = [];

  constructor(public loginStore: LoginStore,
              private mapStore: MapStore,
              private formStore: FormStore,
              private fieldStore: FieldStore,
              private mapViewStore: MapViewStore,
              private settingsStore: SettingsStore,
              private languageStore: LanguageStore,
              private translationStore: TranslationStore,
              private modalDialogStore: ModalDialogStore,
              private campaignYearStore: CampaignYearStore,
              private nFertilizationStore: NFertilizationStore,
              private monitoringTypeStore: MonitoringTypeStore,
              private monitoringFieldStore: MonitoringFieldStore,
              private monitoringDetailStore: MonitoringDetailStore,
              private plantProtectionPlanBooksStore: PlantProtectionPlanBookStore,
              private dateService: ApDateService,
              private cropService: ApGetCropService,
              private nFertilizationService: NFertilizationService,
              private plantProtectionService: PlantProtectionService,
              private modalDialogPresets: ModalDialogPresets,
              private monitoringConfig: MonitoringConfig,
              private translationService: ApTranslationService,
              private statisticStore: StatisticStore,
              private cropGroupStore: CropGroupStore,
              private statisticService: StatisticService,
              private baseFertilizationSummaryStore: BasicFertilisationSummariesStore) {
  }

  public ngOnInit(): void {
    this._handleHalfMapAndGridView();
    this._setLoading();
    this._buildGrid();
    this._buildItems();
  }

  public ngAfterViewInit(): void {
    this._subscriptions.push(this.dynComponent.SelectedItems$.subscribe((items: MonitoringGridItem[]) => {
      this._handleSelectionChange(items);
    }));
    this._subscriptions.push(this.formStore.FormClose$.subscribe(() => {
      const selectedItems = this.dynComponent.getSelectedItems() as MonitoringGridItem[];
      setTimeout(() => this._handleSelectionChange(selectedItems), 1);
    }));
    this._subscriptions.push(this.campaignYearStore.SelectedCampaignYear$.subscribe(() => {
      setTimeout(() => {
        this.monitoringTypeStore.loadMonitoringTypes();
        this.monitoringFieldStore.loadMonitoringFields();
        this.monitoringDetailStore.loadMonitoringDetails();
        this.plantProtectionPlanBooksStore.loadPlanBooks();
        this.nFertilizationStore.LoadNFertilizationPlanningSummaries();
        this.nFertilizationStore.LoadLogfiles();
      }, 0);
    }));

    this._subscriptions.push(this._statisticUpdateRequested.pipe(
      debounceTime(100)).subscribe(_ => this._generateStats()));
    this._subscriptions.push(this.items$.subscribe(_ => this._statisticUpdateRequested.emit()));

    this._subscriptions.push(
      combineLatest([
        this.mapViewStore.Listen(s => s.mode),
        this.mapViewStore.Listen(s => s.currentMenu)
      ]).subscribe(([mapMode, mapMenu]) => {
          if (mapMode !== MapViewMode.HIDE && mapMenu === MapViewCurrentMenu.STATS) {
            this._statisticUpdateRequested.emit();
          }
        }
      ));
  }

  public ngOnDestroy(): void {
    this.statisticStore.removeStatisticData();
    this.fieldStore.changeSelectedField([]);
    this._subscriptions.forEach(x => x?.unsubscribe());
  }

  /**
   * Opens the monitoring field entry form for creating a new monitoring field.
   * Initializes form with null data to indicate new entry mode.
   * @public
   */
  public onCreate(): void {
    this.formStore.openForm({component: ApMonitoringFieldEntryComponent, data: null});
  }

  /**
   * Combines loading states from multiple stores.
   * @private
   */
  private _setLoading(): void {
    this.loading$ = combineLatest([
      this.fieldStore.Loading$,
      this.settingsStore.Loading$,
      this.languageStore.Loading$,
      this.campaignYearStore.Loading$,
      this.nFertilizationStore.Loading$,
      this.monitoringTypeStore.Loading$,
      this.monitoringFieldStore.Loading$,
      this.monitoringDetailStore.Loading$,
      this.plantProtectionPlanBooksStore.Loading$
    ]).pipe(
      map((loadings) => loadings.some(loaded => loaded))
    );
  }

  /**
   * Initializes grid components with columns and configuration.
   * Sets up two column sets:
   * - Main grid columns with create/delete actions;
   * - Details grid columns with edit/delete actions;
   * Sets up pager for grid.
   * Configures column settings based on language and application settings.
   * @private
   */
  private _buildGrid(): void {
    this.columns$ = combineLatest([
      this.settingsStore.FirstSetting$,
      this.languageStore.SelectedLanguage$
    ]).pipe(
      map(([setting, language]) => {
        const menuButtons: DropDownButtonData[] = [
          {
            text: 'NewMonitoringDetail',
            callback: ApUtilService.createEventEmitter(this._createMonitoringDetail.bind(this), this._subscriptions),
            disabled: (dataItem: MonitoringGridItem) => dataItem.Status.state === -1
          },
          {
            text: 'Global__Delete',
            callback: ApUtilService.createEventEmitter(this._deleteMonitoringField.bind(this), this._subscriptions),
            disabled: (dataItem: MonitoringGridItem) => dataItem.Status.state === -1
          }
        ];
        return this.monitoringConfig.getMainGridColumns(menuButtons, setting, language);
      })
    );
    this.detailsColumns$ = combineLatest([
      this.settingsStore.FirstSetting$,
      this.languageStore.SelectedLanguage$
    ]).pipe(
      map(([setting, language]) => {
        const burgerMenuButtons: DropDownButtonData[] = [
          {
            text: 'EditMonitoringDetail',
            callback: ApUtilService.createEventEmitter(this._editMonitoringDetail.bind(this), this._subscriptions),
            disabled: (dataItem: MonitoringChildGridItem) => dataItem.Status.state === -1
          },
          {
            text: 'DeleteMonitoringDetail',
            callback: ApUtilService.createEventEmitter(this._deleteMonitoringDetail.bind(this), this._subscriptions),
            disabled: (dataItem: MonitoringChildGridItem) => dataItem.Status.state === -1
          }
        ];
        return this.monitoringConfig.getDetailsGridColumns(burgerMenuButtons, setting, language);
      })
    );
    this.pager = this.monitoringConfig.getPager();
  }

  /**
   * Sets loading state for grid depending on loading state from stores.
   * Processes and combines monitoring data, plan books data with field to build grid items.
   * @private
   */
  private _buildItems(): void {
    this._subscriptions.push(
      combineLatest([
        this.fieldStore.Fields$,
        this.monitoringFieldStore.MonitoringFields$,
        this.monitoringDetailStore.MonitoringDetails$,
        this.monitoringTypeStore.MonitoringTypes$,
        this.nFertilizationStore.PlanBooks$,
        this.nFertilizationStore.Logfiles$,
        this.plantProtectionPlanBooksStore.PlanBooks$,
        this.monitoringDetailStore.Loading$,
        this.baseFertilizationSummaryStore.Summaries$
      ]).pipe(
        filter(([_, monitoringFields, monitoringDetails, _1, _2, _3, _4, detailsLoading, _5]) => !!monitoringFields && !!monitoringDetails && !detailsLoading),
        map(([fields, monitoringFields, monitoringDetails, monitoringTypes, nPlanBooks, nLogFiles, ppPlanBooks, _, baseFertSummaries]) => {
          return monitoringFields.map(monitoringField => {
            const field = fields.find(x => x.Id === monitoringField.FieldId);
            const fieldGeom = this.fieldStore.getCurrentFieldGeom(field);
            const mainCropDescription = this.cropService.parseMainCrop(field);
            const details = this._getDetailsForMonitoringField(monitoringField.Id, field, monitoringDetails, monitoringTypes);
            const latestDetailDate = this._getLatestDetail(details);
            const highestDetailEcValue = this._getHighestEcValueFromDetails(details);
            const gridStatus = this._getMonitoringFieldStatus(fieldGeom, latestDetailDate);
            const baseFertPlanBooks = baseFertSummaries.map(x => x.BasicFertilisationPlanBooks).flat().filter(p => p.BookedAt);
            const nFertilizationApplications = this.nFertilizationService.getContentNRelatedPlanBooks(field, nPlanBooks, nLogFiles, baseFertPlanBooks);
            const planProtectionApplications = this.plantProtectionService.getPpApplications(field, ppPlanBooks);
            const latestNApplicationDate = this._getLatestApplicationDateForField(field, nFertilizationApplications);
            const latestPpApplicationDate = this._getLatestApplicationDateForField(field, planProtectionApplications);
            const item: MonitoringGridItem = {
              Id: monitoringField.Id,
              Status: gridStatus,
              FieldId: field?.Id,
              FieldName: field?.FieldName,
              FieldNumber: field?.FieldNumber,
              FieldDefaultGeom: field?.DefaultGeom,
              FieldSecondNumber: field?.FieldSubnumber,
              FieldCombinedNumber: this.fieldStore.getFieldNumberAndSubNumber(field),
              CropName: mainCropDescription,
              EcValue: highestDetailEcValue,
              Area: fieldGeom?.AreaHa,
              LatestMeasurementDate: latestDetailDate,
              LatestNApplicationDate: latestNApplicationDate,
              LatestPpApplicationDate: latestPpApplicationDate,
              Details: details,
              ContentNRelatedPlanBooks: nFertilizationApplications
            };
            return item;
          });
        })
      ).subscribe(items => {
        this.items$.next(items);
        this.displayDetailsPositions();
      })
    );
  }

  public displayDetailsPositions(): void {
    this.mapStore.Layers.GeoPointsLayer.deleteAllPoints();
    this.mapStore.Layers.GeoPointsLayer.Visibility = true;
    this.items$.value.forEach(item => {
      item.Details?.forEach((detail) => {
        if (detail.Position) {
          this.mapStore.Layers.GeoPointsLayer.addPoint(detail.Id, (detail.Position as unknown as Point).coordinates);
        }
      });
    });
  }

  /**
   * Maps monitoring details to child grid items for a specific monitoring field.
   * @param monitoringFieldId ID of the monitoring field.
   * @param field the corresponding field
   * @param monitoringDetails Array of all monitoring details.
   * @param monitoringTypes Array of all monitoring types.
   * @returns Array of child grid items.
   * @private
   */
  private _getDetailsForMonitoringField(monitoringFieldId: IGuid, field: IField, monitoringDetails: IMonitoringDetail[],
                                        monitoringTypes: IMonitoringType[]): MonitoringChildGridItem[] {
    const fieldMonitoringDetails = monitoringDetails.filter(x => x.MonitoringFieldId === monitoringFieldId);
    return fieldMonitoringDetails.map(x => {
      const fieldName = this.fieldStore.getFieldNameById(field?.Id);
      const fieldGeom = this.fieldStore.getCurrentFieldGeom(field);
      const monitoringType = monitoringTypes.find(y => y.Id === x.TypeId);
      const detailItem: MonitoringChildGridItem = {
        Id: x.Id,
        MonitoringFieldId: monitoringFieldId,
        FieldName: fieldName,
        FieldId: field?.Id?.toString(),
        Status: {
          state: !!fieldGeom?.Id ? ApColumnState.Green : ApColumnState.Red,
          class: !!fieldGeom?.Id ? 'ap-status-green' : 'ap-status-red',
          description: ''
        },
        TypeName: this.translationStore.FindTranslationForSelectedLanguage(monitoringType.TranslationKey),
        TypeId: monitoringType.Id,
        Type: monitoringType,
        Date: new Date(x.Date),
        Value: x?.Value,
        Recommendation: x?.Recommendation,
        EcValue: x.EcStage,
        Notes: x.Notes,
        Position: x.Position,
        FilesCount: x.Attachments?.length ?? 0
      };
      return detailItem;
    });
  }

  /**
   * Determines monitoring field status based on creation date.
   * Status colors:
   * - Green: ≤7 days old;
   * - Yellow: 8-14 days old;
   * - Grey: >14 days old;
   * - Red: No field geometry or created date not set.
   * @param fieldGeom Field geometry to validity check.
   * @param createdDate Date to evaluate.
   * @returns Grid status object with state and styling.
   * @private
   */
  private _getMonitoringFieldStatus(fieldGeom: IFieldGeom | undefined, createdDate: Date | undefined): IGridStatus {
    const status: IGridStatus = {state: ApColumnState.Red, class: 'ap-status-red', description: ''};
    if (!fieldGeom?.Id || !createdDate) {
      return {state: ApColumnState.Red, class: 'ap-status-red', description: 'Monitoring__status_red'};
    }
    const dateTimeUtc = this.dateService.getUtc();
    const dateDiffInDays = this.dateService.getDateDiff(createdDate, dateTimeUtc, DateDiffType.Days);
    if (dateDiffInDays >= -7) {
      return {state: ApColumnState.Green, class: 'ap-status-green', description: 'Monitoring__status_green'};
    } else if (dateDiffInDays >= -14) {
      return {state: ApColumnState.Yellow, class: 'ap-status-yellow', description: 'Monitoring__status_yellow'};
    } else if (dateDiffInDays < -14) {
      return {state: ApColumnState.Grey, class: 'ap-status-grey', description: 'Monitoring__status_grey'};
    }
    return status;
  }

  /**
   * Finds highest EC value among monitoring details.
   * @param details Array of monitoring detail items.
   * @returns Highest EC value or undefined if no details.
   * @private
   */
  private _getHighestEcValueFromDetails(details: MonitoringChildGridItem[]): number | undefined {
    if (details.length <= 0) {
      return undefined;
    }
    const highestEcValueObject = details.reduce((max, detail) => {
      return detail.EcValue > max.EcValue ? detail : max;
    });
    return highestEcValueObject.EcValue;
  }

  /**
   * Retrieves date of most recent monitoring detail.
   * @param details Array of monitoring detail items.
   * @returns Most recent date or undefined if no details.
   * @private
   */
  private _getLatestDetail(details: MonitoringChildGridItem[]): Date | undefined {
    const sortedDetailsByDate = details.sort((a, b) => b.Date.getTime() - a.Date.getTime());
    return sortedDetailsByDate[0]?.Date;
  }

  /**
   * Gets the latest application date for a specific field
   * @param field - Target field
   * @param planBooks - Array of plan book application dates
   * @returns Latest application date or undefined if no dates exist
   * @private
   */
  private _getLatestApplicationDateForField(field: IField | undefined,
                                            planBooks: PlanBookApplicationDateObject[]): Date | undefined {
    if (!field?.Id || !planBooks || planBooks.length === 0) {
      return undefined;
    }
    const planBooksForCurrentField = planBooks.filter(pb => pb.FieldId === field.Id && !!pb.ApplicationDate);
    return new Date(Math.max(...planBooksForCurrentField.map(planBook => new Date(planBook.ApplicationDate).getTime())));
  }

  /**
   * Manages the map and grid view state:
   * 1. Clears selected fields;
   * 2. Ensures proper map view mode;
   * 3. Adjusts zoom to show all farm fields;
   * @private
   */
  private _handleHalfMapAndGridView(): void {
    this.fieldStore.changeSelectedField([]);
    if (this.mapViewStore.getMapViewMode() !== MapViewMode.NORMAL) {
      this.mapViewStore.goIntoMapMenu();
    }
    if (this.mapViewStore.getMapViewCurrentMenu() !== MapViewCurrentMenu.MAP) {
      this.mapViewStore.goIntoMapMenu();
    }
    this.fieldStore.zoomFarmFields();
  }

  /**
   * Updates field selection based on grid item selection.
   * Zooms to farm fields if no items selected.
   * @param itemsToSelect Selected monitoring grid items
   * @private
   */
  private _handleSelectionChange(itemsToSelect: MonitoringGridItem[]): void {
    const selectedFieldIds = itemsToSelect.filter(x => !!x.FieldId).map(x => x.FieldId.toString());
    this.fieldStore.changeSelectedField(selectedFieldIds);
    if (selectedFieldIds.length <= 0) {
      this.fieldStore.zoomFarmFields();
    }
    this._statisticUpdateRequested.emit();
  }

  /**
   * Deletes a monitoring field with confirmation for existing details
   * @param dataItem - Grid item containing monitoring field data
   * Shows confirmation dialog if monitoring details exist
   * Directly deletes if no details are associated
   * @private
   */
  private _deleteMonitoringField(dataItem: MonitoringGridItem): void {
    if (!dataItem?.Id) {
      return;
    }
    const monitoringDetails = this.monitoringDetailStore.MonitoringDetails.filter(x => x.MonitoringFieldId === dataItem.Id);
    if (monitoringDetails.length > 0) {
      this.modalDialogStore.setModalDialogData(this.modalDialogPresets.DeleteDialog({
        message: 'DeleteMonitoringWithMonitoringDetails',
        resultDelegate: (dialogData, _) => {
          if (dialogData?.key === ModalDialogButtonKeys.Delete) {
            this.monitoringFieldStore.deleteMonitoringField(dataItem.Id);
          }
        }
      }));
    } else {
      this.monitoringFieldStore.deleteMonitoringField(dataItem.Id);
    }
  }

  /**
   * Opens form to create new monitoring detail.
   * @param dataItem Grid item for parent monitoring field
   * @private
   */
  private _createMonitoringDetail(dataItem: MonitoringGridItem): void {
    if (!dataItem?.Id || !dataItem?.FieldDefaultGeom) {
      return;
    }

    const fieldPolygon: Polygon = this.mapStore.Layers.FieldsLayer.layer.getSource().getFeatureById(dataItem.FieldDefaultGeom.Id.toString()).getGeometry() as Polygon;
    this.mapStore.Layers.GeoPointsLayer.addPoint('NEW', fieldPolygon.getCoordinates()[0][0], true, false);
    const data: MonitoringDetailEntryComponentData = {
      MonitoringDetailId: undefined,
      MonitoringFieldId: dataItem.Id
    };
    this.formStore.openForm({component: ApMonitoringDetailEntryComponent, data});
  }

  /**
   * Opens form to edit existing monitoring detail.
   * @param dataItem Child grid item containing detail to edit
   * @private
   */
  private _editMonitoringDetail(dataItem: MonitoringChildGridItem): void {
    if (!dataItem?.Id || !dataItem?.MonitoringFieldId) {
      return;
    }

    this.dynComponent.dynGrid.gridPaging.setSelectedKeys([dataItem.MonitoringFieldId]);

    this.mapStore.Layers.GeoPointsLayer.addPoint(dataItem.Id, (dataItem.Position as unknown as Point).coordinates, true);
    const data: MonitoringDetailEntryComponentData = {
      MonitoringDetailId: dataItem.Id,
      MonitoringFieldId: dataItem.MonitoringFieldId
    };
    this.formStore.openForm({component: ApMonitoringDetailEntryComponent, data});
  }

  /**
   * Deletes a monitoring detail with confirmation for last detail
   * @param dataItem - Child grid item containing detail data
   * Shows confirmation dialog if deleting last detail of monitoring field
   * Directly deletes if other details exist
   * @private
   */
  private _deleteMonitoringDetail(dataItem: MonitoringChildGridItem): void {
    if (!dataItem?.Id) {
      return;
    }
    const monitoringDetails = this.monitoringDetailStore.MonitoringDetails.filter(x => x.MonitoringFieldId === dataItem.MonitoringFieldId);
    if (monitoringDetails.length === 1) {
      this.modalDialogStore.setModalDialogData(this.modalDialogPresets.DeleteDialog({
        message: 'DeleteLastMonitoringDetailWithMonitoringField',
        resultDelegate: (dialogData, _) => {
          if (dialogData?.key === ModalDialogButtonKeys.Delete) {
            this.monitoringDetailStore.deleteMonitoringDetail(dataItem.Id);
          }
        }
      }));
    } else {
      this.monitoringDetailStore.deleteMonitoringDetail(dataItem.Id);
    }
  }

  /**
   * Generates the statistic charts for the selected monitorings.
   * There is one chart per monitoring type.
   * Each chart contains a data series (line, points or columns) for each monitoring field.
   * All charts have the same date range (same min/max date)
   * @private
   */
  private _generateStats(): void {
    if (this.mapViewStore.getMapViewCurrentMenu() !== MapViewCurrentMenu.STATS || this.mapViewStore.getMapViewMode() === MapViewMode.HIDE) {
      return;
    }
    const emptyTitle = `${this.translationService.translate('Nutrients__StatisticsTitle')}\n${this.translationService.translate('Monitoring')}`;
    let items = this.dynComponent.getSelectedItems() as MonitoringGridItem[];
    if (!items || items?.length === 0) {
      items = this.dynComponent.items as MonitoringGridItem[];
    }
    if (!items || items?.length === 0) {
      this.statisticStore.setStatisticData<GenericChartConfig>(
        [], ApStatsType.GenericBars, emptyTitle, emptyTitle
      );
      return;
    }

    const chartConfigs: GenericChartConfig[] = [];
    // collect all monitoring details and group them and exclude details with not unit
    const monitoringDetails = items.map(item => item.Details).flat().FindAll(d => d.Type?.ValueUnit != null);
    const monitoringDates = monitoringDetails.map(d => d.Date.valueOf());
    let minDate = this.dateService.getDateMidnight(new Date(monitoringDates.Min()));
    let maxDate = this.dateService.getEndOfDayDate(new Date(monitoringDates.Max()));
    let statRelatedNApplications: IContentNRelatedPlanBook[] = [];
    // in case of any n_tester or nitrate check monitoring, we want to load
    // booked n-applications as well and add them to the statistics.
    // in case we found n-applications, the date-range might need to be extended as well
    if (monitoringDetails.Any(d => d.Type?.TranslationKey === 'N_TESTER' || d.Type?.TranslationKey === 'NITRATE_CHECK')) {
      statRelatedNApplications = this._findStatRelatedNApplications(items, minDate);
      if (statRelatedNApplications && statRelatedNApplications.length > 0) {
        const foundNApplicationDates = statRelatedNApplications.map(p => p.PlanBookApplicationDate.valueOf());
        const minDateApplications = this.dateService.getDateMidnight(new Date(foundNApplicationDates.Min()));
        const maxDateApplications = this.dateService.getEndOfDayDate(new Date(foundNApplicationDates.Max()));
        if (minDateApplications < minDate) {
          minDate = minDateApplications;
        }
        if (maxDateApplications > maxDate) {
          maxDate = maxDateApplications;
        }
      }
    }

    // let's group all monitoring details by monitoring type to assign those details to the same chart
    const monitoringDetailsByType = monitoringDetails.GroupBy(detail => detail.TypeId);
    for (const monitoringTypeId of Object.keys(monitoringDetailsByType)) {
      const monitoringType = this.monitoringTypeStore.MonitoringTypes.FirstOrDefault(m => m.Id?.toString() === monitoringTypeId);
      // skip monitoring types without units (e.g., diseases => makes no sense to have that in the statistic
      if (!monitoringType?.ValueUnit) {
        continue;
      }
      const details = monitoringDetailsByType[monitoringTypeId];
      const chartConfig = this._generateStatChartConfig(details, monitoringType, minDate, maxDate);
      chartConfig.noteField = nameOf<GenericSeriesData>('yValue');
      this._generateAppliedNSeries(monitoringType, details, statRelatedNApplications, chartConfig);
      chartConfigs.push(chartConfig);
    }
    this.statisticStore.setStatisticData<GenericChartConfig>(
      chartConfigs, ApStatsType.GenericChart, this._getTitleForStatistic(items), emptyTitle
    );
  }

  /**
   * Generates a chartConfig and series data for a monitoring type
   * @param monitoringDetailsByType the selected items
   * @param monitoringType the monitoring type of the chart to be generated
   * @param minDate the common (over all charts) minDate of category axis (x-axis)
   * @param maxDate the common (over all charts) maxDate of category axis (x-axis)
   * @private
   */
  private _generateStatChartConfig(monitoringDetailsByType: MonitoringChildGridItem[], monitoringType: IMonitoringType, minDate: Date, maxDate: Date): GenericChartConfig {
    // setup basic chart configuration and its axes
    const chartConfig = new GenericChartConfig();
    chartConfig.title = monitoringType?.TranslationKey;
    chartConfig.xAxisConfig.min = minDate?.valueOf();
    chartConfig.xAxisConfig.max = maxDate?.valueOf();
    chartConfig.xAxisConfig.labelDelegate = (xAxisValue: string, dataItem: GenericSeriesData, _: GenericChartConfig) => {
      return dataItem != null ? xAxisValue : '';
    };
    chartConfig.pannable = false;
    chartConfig.zoomable = false;
    chartConfig.xAxisConfig.type = 'date';
    chartConfig.xAxisConfig.baseUnit = 'days';
    chartConfig.axisCrossingValue = [Number.MIN_VALUE, Number.MAX_VALUE];
    // Configuring yAxis (value axis).
    // Here we have the chance to add multiple yAxis and assign the series data to
    // an individual axis by setting the 'axisId' property
    const yAxisConfig = new GenericYAxisConfig();
    yAxisConfig.title = this.translationService.translate(monitoringType?.ValueUnit?.Key);
    chartConfig.yAxisConfigs.push(yAxisConfig);

    // now let's iterate over our monitoring details (details of the given monitoring type).
    // building the series data per monitoring field
    const monitoringDetailsByField = monitoringDetailsByType.GroupBy(detail => detail.MonitoringFieldId);
    for (const monitoringFieldId of Object.keys(monitoringDetailsByField)) {
      const detailsByField = monitoringDetailsByField[monitoringFieldId];
      const fieldId = detailsByField.FirstOrDefault()?.FieldId;
      const seriesConfig = new GenericSeriesConfig();
      seriesConfig.id = fieldId?.toString();
      seriesConfig.type = monitoringType?.TranslationKey === 'PRECIPITATION' ? 'column' : 'line';
      seriesConfig.name = this.fieldStore.getFieldNameById(fieldId);
      seriesConfig.color = this._calculateSeriesColor(monitoringFieldId);
      for (const detail of detailsByField) {
        const seriesData = new GenericSeriesData();
        seriesData.xValue = detail.Date.valueOf();
        seriesData.yValue = detail.Value;
        seriesConfig.seriesData.push(seriesData);
      }
      chartConfig.seriesConfigs.push(seriesConfig);
    }
    return chartConfig;
  }

  /**
   * Generates column-statistics for the average applied N per field and per date.
   * This statistic is based on all booked N and base fertilization (with n-content)
   * @param monitoringType he monitoring a type of the chart to be generated
   * @param details the monitoring details for the currently processed chart/statistic (filtered by monitoring type)
   * @param statNApplications contentN related planBooks
   * @param chartConfig the current chart config
   * @private
   */
  private _generateAppliedNSeries(monitoringType: Data.Fields.IMonitoringType, details: MonitoringChildGridItem[], statNApplications: IContentNRelatedPlanBook[], chartConfig: GenericChartConfig): void {
    if (monitoringType?.TranslationKey !== 'N_TESTER' && monitoringType?.TranslationKey !== 'NITRATE_CHECK' || !statNApplications || statNApplications?.length === 0) {
      return;
    }
    // let's add applied n statistics only for fields which are part of the currently processed monitoring details
    const fieldIds = details.map(d => d.FieldId?.toString());
    const yAxisNApplicationConfig = new GenericYAxisConfig();
    yAxisNApplicationConfig.title = this.translationService.translate('N__ChartTitleY');
    yAxisNApplicationConfig.id = ApGuidUtil.generateNewGuid();
    yAxisNApplicationConfig.min = 0;
    const nApplicationsByField = statNApplications.GroupBy(p => p.FieldId);
    for (const fieldId of Object.keys(nApplicationsByField)) {
      if (!fieldIds.Any(id => id?.toString() === fieldId?.toString())) {
        continue;
      }
      // use color and name from the original monitoring series
      const relatedMonitoringSeries = chartConfig.seriesConfigs.FirstOrDefault(s => s.id === fieldId);
      const nApplicationsForField = nApplicationsByField[fieldId];
      const seriesConfigNApplication = new GenericSeriesConfig();
      seriesConfigNApplication.type = 'column';
      seriesConfigNApplication.axisId = yAxisNApplicationConfig.id;
      seriesConfigNApplication.name = relatedMonitoringSeries?.name;
      seriesConfigNApplication.color = relatedMonitoringSeries?.color;
      seriesConfigNApplication.hideLegend = true; // to avoid duplicate legend items (same legend item coming from monitoring statistics)

      // Group n applications by date (same like monitoring statistic)
      const nApplicationsByDate = nApplicationsForField.GroupBy(p => p.PlanBookApplicationDate.valueOf());
      for (const nApplicationDate of Object.keys(nApplicationsByDate)) {
        const nApplications = nApplicationsByDate[nApplicationDate];
        if (!nApplications || nApplications.length === 0) {
          continue;
        }
        const appliedN = nApplications.map(n => n.NFertilization?.Average);
        const avgAppliedN = appliedN.length > 0 ? appliedN.reduce((a, b) => a + b)  : 0;
        const seriesData = new GenericSeriesData();
        seriesData.xValue = +nApplicationDate;
        seriesData.yValue = Math.round(avgAppliedN);
        seriesConfigNApplication.seriesData.push(seriesData);
      }
      chartConfig.seriesConfigs.push(seriesConfigNApplication);
    }
    chartConfig.yAxisConfigs.push(yAxisNApplicationConfig);
  }

  /**
   * Finds all booked content-n related planbooks (N and base fertilization)
   * for a specific period of time.
   * @param items the selected (or all) grid items
   * @param minDateMonitoring the oldest monitoring date within the user's selection
   * @private
   */
  private _findStatRelatedNApplications(items: MonitoringGridItem[], minDateMonitoring: Date): IContentNRelatedPlanBook[] {
    const fieldIdsRelevantForNApplications = items?.FindAll(i =>
      i.Details?.Any(d => d.Type?.TranslationKey === 'N_TESTER' || d.Type?.TranslationKey === 'NITRATE_CHECK')).map(i => i.FieldId);
    const campaignYearStart = new Date(this.campaignYearStore.SelectedCampaignYear.DefaultStart);
    const newYear = new Date(campaignYearStart.getFullYear(), 11, 31, 23, 59, 59);
    // let's find booked n plannings based on the date of the oldest monitoring
    // - if monitoring took place in the first half of the campaignYear => start searching from 01.08.
    // - otherwise start searching for planbooks from 01.01
    const minDatePlanBookFilter = (minDateMonitoring > campaignYearStart && minDateMonitoring < newYear) ? campaignYearStart : newYear;
    return items.map(item => item.ContentNRelatedPlanBooks).flat()
      .FindAll(p => p.BookedAt != null &&
        p.PlanBookApplicationDate > minDatePlanBookFilter &&
        fieldIdsRelevantForNApplications.Any(id => id?.toString() === p.FieldId?.toString()));
  }

  /**
   * Generates the statistics title
   * @param selectedItems selected grid items
   * @private
   */
  private _getTitleForStatistic(selectedItems: MonitoringGridItem[]): string {
    const totalItems = this.dynComponent.items as MonitoringGridItem[];
    const dataForTitles = totalItems.map(x => ({
      AreaHa: x.Area,
      Selected: selectedItems.some(z => z.Id === x.Id)
    }));
    return this.statisticService.generateFieldsAreaTitle(dataForTitles);
  }

  /**
   * Calculates the chart series color.
   * The idea is to have the same color in each chart for data series of the same field.
   * Here we are using the cropGroup colors as source colors and cycle through them
   * to assign them to those monitoring fields. If there are more monitoring fields
   * than available colors, it is accepted behavior to have duplicated colors in the charts.
   * @param monitoringFieldId
   * @private
   */
  private _calculateSeriesColor(monitoringFieldId: string): string {
    // as per definition, we are using our cropGroup colors here
    // each monitoring field should have the same color in each chart
    const colors = this.cropGroupStore.getCropGroups().map(c => c.Colordefault);
    const monitoringFields = this.dynComponent.items as MonitoringGridItem[];
    const monitoringFieldIndex = monitoringFields.FindIndex(f => f.Id?.toString() === monitoringFieldId);
    // Cycle through the colors. Yes, the color is reused if the number of fields exceeds the available colors
    return colors[monitoringFieldIndex % colors.length];
  }
}
